import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { useAuth0 } from './auth0-wrapper';
import { TENANT_QUERY } from './components/admin-portal/tenant-admin/gql-model';
import useLocalStorage from './utils/useLocalStorage';

const ALL_TENANTS_QUERY = gql`
  query ALL_TENANTS_QUERY {
    tenants {
      id
      name
    }
  }
`;
export const tenantContext = React.createContext();

const TenantProvider = ({ children }) => {
  const { user } = useAuth0();

  const dapClaims = user['https://dap.covis.de'] || {};
  let tenantIdParam = null;
  const params = new URLSearchParams(window.location.search);
  if (params.has('tenantId')) {
    try {
      tenantIdParam = params.get('tenantId');
    } catch (error) {
      console.log(error);
    }
  }

  const [tenantId, setTenantId] = useLocalStorage(
    'selectedTenantId',
    +dapClaims.tenant
  );
  useEffect(() => {
    if (dapClaims && dapClaims.tenant) {
      setTenantId(+dapClaims.tenant);
    }
  });

  const [loadTenant, { called, loading, data, error }] = useLazyQuery(
    TENANT_QUERY
  );

  const { loading: loadingAllTenants } = useQuery(ALL_TENANTS_QUERY, {
    fetchPolicy: 'cache-and-network',
    skip: dapClaims?.tenant,
    onCompleted: tenantsData => {
      if (tenantsData && tenantsData.tenants) {
        const ids = [];
        tenantsData.tenants.forEach(item => {
          ids.push(item.id);
        });
        if (tenantIdParam && ids.includes(tenantIdParam)) {
          setTenantId(tenantIdParam);
        } else if (dapClaims.tenant) {
          setTenantId(+dapClaims.tenant);
        }
      }
    },
  });

  useEffect(() => {
    if (tenantId) {
      loadTenant({ variables: { id: +tenantId } });
    }
  }, [loadTenant, tenantId]);

  if (tenantId && !called) return <p>Loading...</p>;
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const tenant =
    tenantId && data && data.tenants_by_pk ? data && data.tenants_by_pk : null;
  return (
    <tenantContext.Provider value={{ tenantId, setTenantId, tenant }}>
      {children}
    </tenantContext.Provider>
  );
};

TenantProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default TenantProvider;
